import React, { useEffect } from 'react';
import { faComment } from '@fortawesome/free-solid-svg-icons';
import Button from 'components/elements/Button';

const KakaoShareButton = ({ label, url }) => {
  useEffect(() => {
    createKakaoButton();
  });
  const createKakaoButton = () => {
    // kakao sdk script이 정상적으로 불러와졌으면 window.Kakao로 접근이 가능합니다
    if (window.Kakao) {
      const kakao = window.Kakao;
      if (!kakao.isInitialized()) {
        kakao.init(process.env.REACT_APP_KAKAO_KEY);
      }
      kakao.Link.createDefaultButton({
        container: '#kakao-link-btn',

        objectType: 'feed',
        content: {
          title: '[집콕취미찾기] 나 이거 좋아했네',
          description: '내 성향과 찰떡인 집콕 취미 찾기',
          imageUrl: 'https://untacthobby.web.app/cover_square.png',
          link: {
            mobileWebUrl: url,
            webUrl: url,
          },
        },
        buttons: [
          {
            title: '자세히 보기',
            link: {
              mobileWebUrl: url,
              webUrl: url,
            },
          },
        ],
      });
    }
  };
  return (
    <div>
      <Button
        id={'kakao-link-btn'}
        color={'rgba(0, 0, 0, 0.8)'}
        bgColor={'#ffcc00'}
        label={label}
        icon={faComment}
      />
    </div>
  );
};

KakaoShareButton.defaultProps = {
  label: '결과 공유하기',
  url: window.location.href,
};
export default KakaoShareButton;
